import React, { useEffect } from 'react';
import { Card } from '@material-ui/core';
import { useStyles } from '../../styles/styles';
import { useDispatch, useSelector } from 'react-redux';
import { LoadProfileAction, DecisionUserAction } from '../../redux/actions/ProfileActions';
import SimpleMenu from '../../components/layouts/Navigation';
import DataGridDemo from './UserListing';
import { DataGrid } from "@material-ui/data-grid";
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import { useHistory, Link } from 'react-router-dom';
export default function DecisionComponent() {
    const classes = useStyles();

    const dispatch = useDispatch();
    const history = useHistory();
    const profileResponse = useSelector(state => state.userDetails.userProfile);


    useEffect(() => {
        let abortController;
        abortController = new AbortController();
        let signal = abortController.signal;  
        dispatch(DecisionUserAction(signal));

        if (Object.keys(profileResponse).includes('message')){
            if([3,4].includes(profileResponse.data.role_users_id)){
                history.push('/customer-details/' + profileResponse.data.id)
            } else if (10 == profileResponse.data.role_users_id){
                history.push('/chalani');
            }else{
                history.push('/applications-list');
            }
        }
        return () => {
            abortController.abort();
        };
    }, [!Object.keys(profileResponse).includes('message')])

    return (
        <>


            <div className={classes.root}>
                <Grid container className={classes.bodyWrapper}>
                    <Grid item xs={3}>
                      
                    </Grid>
                    <Grid item xs={9}>

                        <Paper className={classes.paper} style={{display: "flex", flexDirection: 'column', position: "absolute", top: "10%", left: "50%", transform:"translate(-50%,-50%)"}}>We are loading.... </Paper>
                    </Grid>
               

                 

                </Grid>
            </div>

        </>

    );
}
